import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import { css } from "@emotion/react";
import { fastlyPricing, pricingInfo } from "../../data/pricing-page-data";
import { pxToRem } from "@upsun/react-component-library/src/styles";

type EdgeTableProps = {
  currency: string
};

const EdgeTable: React.FC<EdgeTableProps> = ({ currency }) => {
  const smallMargin = css`
    margin-bottom: ${pxToRem(16)} !important;
  `;

  return (
    <PricingTable>
      <tbody>
      <tr>
          <BoldCell>Bandwidth</BoldCell>
          <td>
            <span><strong>Included egress transfer:</strong><br/>10 GB/project/month</span>
            <br/>
            <span><strong>Additional egress transfer:</strong><br/>{pricingInfo.egressBandwidth[currency]}/GB</span>
          </td>
        </tr>
        <tr>
          <BoldCell>Requests</BoldCell>
          <td>
            <span><strong>Included ingress requests:</strong><br/>500,000 requests/month</span>
            <br />
            <span><strong>Additional ingress requests:</strong><br/>{pricingInfo.ingress[currency]}/100,000 requests</span>
          </td>
        </tr>
        <tr>
          <BoldCell>Fastly CDN</BoldCell>
          <td>
            <span><strong>Fastly CDN Transfer:</strong><br/>{pricingInfo.fastlyBandwidth[currency]}/GB</span>
            <br/>
            <span><strong>Fastly CDN Requests:</strong><br/>{pricingInfo.fastlyRequests[currency]}/100,000 requests</span>
          </td>
        </tr>
        <tr>
          <BoldCell>Fastly WAF - Basic<sup>†</sup></BoldCell>
          <td>
            <p css={smallMargin}><strong>Tiered pricing:</strong></p>
            <ul>
              <li>First 0–1M requests:<br/>{fastlyPricing.basic["0-1M"][currency]} per million requests</li>
              <li>Next million requests (for up to 2M total):<br/>{fastlyPricing.basic["1-2M"][currency]} per million requests</li>
              <li>Next million requests (for up to 3M total):<br/>{fastlyPricing.basic["2-3M"][currency]} per million requests</li>
              <li>Beyond 3 million requests:<br/>{fastlyPricing.basic["3M+"][currency]} per million requests</li>
            </ul>
          </td>
        </tr>
        <tr>
          <BoldCell>Fastly WAF - Configurable<sup>†</sup></BoldCell>
          <td>
            <p css={smallMargin}><strong>Tiered pricing:</strong></p>
            <ul>
              <li>First 0–2M requests:<br/>{fastlyPricing.configurable["0-2M"][currency]} flat fee</li>
              <li>Next million requests (for up to 3M total):<br/>{fastlyPricing.configurable["2-3M"][currency]} per million requests</li>
              <li>Beyond 3 million requests:<br/>{fastlyPricing.configurable["3M+"][currency]} per million requests</li>
            </ul>
          </td>
        </tr>
        <tr>
          <BoldCell>Fastly Image Optimization<sup>†</sup></BoldCell>
          <td>
            <p css={smallMargin}><strong>Tiered pricing (per 10 million images):</strong></p>
            <ul>
              <li>First 0–50M requests:<br/>{fastlyPricing.imageOptimization["0-50M"][currency]} per 10 million</li>
              <li>Beyond 50 million requests:<br/>{fastlyPricing.imageOptimization["50M+"][currency]} per 10 million</li>
            </ul>
          </td>
        </tr>
        <tr>
          <BoldCell>Fastly Rate Limiting<sup>†</sup></BoldCell>
          <td>{fastlyPricing.rateLimiting[currency]} without WAF<br/>
          Included with Basic or Configurable WAF</td>
        </tr>
        <tr>
          <BoldCell>Fastly TLS Certificates<sup>†</sup></BoldCell>
          <td>
            <span><strong>Standard TLS:</strong><br/>{fastlyPricing.tlsCertificates.standard[currency]} flat fee for 1-5 certificates<br/>{fastlyPricing.tlsCertificates.standard[currency]} per certificate beyond 5</span>
            <br/>
            <span><strong>Customer generated TLS:</strong><br/>{fastlyPricing.tlsCertificates.customerGenerated[currency]}</span>
          </td>
        </tr>
        <tr>
          <BoldCell>DDoS protection<sup>†</sup></BoldCell>
          <td>{fastlyPricing.ddosProtection[currency]}</td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default EdgeTable;
